<div class="overflow-x-auto">
  <div class="flex justify-end items-center mb-4">
    <div>
      <label class="block font-medium mb-1 text-gray-500">Buscar</label>
      <div class="relative">
        <input
          type="text"
          class="border border-gray-300 rounded-lg py-2 pl-10 pr-4 w-full focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="{{ searchPlaceholder }}"
          [(ngModel)]="searchText"
          (input)="applyFilter()"
        />
        <i class="fas fa-search absolute top-3 left-3 text-gray-500"></i>
      </div>
    </div>
  </div>

  <table
    class="min-w-full table- border-collapse border border-gray-300 text-left"
  >
    <thead>
      <tr class="bg-gray-100 text-left">
        <th
          *ngFor="let col of columns"
          class="py-2 px-4 border-b border-gray-200"
        >
          {{ col.label }}
        </th>
        <th
          *ngIf="actions.length > 0"
          class="py-2 px-4 border-b border-gray-300 text-center"
        >
          Acciones
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let item of paginatedData"
        class="hover:bg-gray-50 transition-colors"
      >
        <td
          *ngFor="let col of columns"
          class="py-2 px-4 border-b border-gray-200"
        >
          <ng-container [ngSwitch]="col.key">
            <!-- Estado -->
            <span
              *ngSwitchCase="'estado'"
              [ngClass]="{
                'bg-green-500': getNestedProperty(item, col.key) === 1,
                'bg-red-500': getNestedProperty(item, col.key) === 0
              }"
              class="px-3 py-1 rounded-full text-white"
            >
              {{ getEstadoLabel(getNestedProperty(item, col.key)) }}
            </span>

            <!-- Nivel Alcanzado -->
            <span
              *ngSwitchCase="'nivel_alcanzado'"
              [ngClass]="
                getNivelAlcanzadoInfo(getNestedProperty(item, col.key)).class
              "
              class="px-3 py-1 rounded-full text-white"
            >
              {{
                getNivelAlcanzadoInfo(getNestedProperty(item, col.key)).label
              }}
            </span>

            <!-- Fechas -->
            <span *ngSwitchCase="'fecha_evaluacion'">
              {{ getNestedProperty(item, col.key) | date : "dd/MM/yyyy" }}
            </span>
            <span *ngSwitchCase="'fecha_inicio'">
              {{ getNestedProperty(item, col.key) | date : "dd/MM/yyyy" }}
            </span>
            <span *ngSwitchCase="'fecha_fin'">
              {{ getNestedProperty(item, col.key) | date : "dd/MM/yyyy" }}
            </span>

            <!-- Otros campos -->
            <span *ngSwitchDefault>
              {{ getNestedProperty(item, col.key) }}
            </span>
          </ng-container>
        </td>

        <td
          *ngIf="actions.length > 0"
          class="py-2 px-4 border-b border-gray-200 text-center whitespace-nowrap"
        >
          <button
            *ngFor="let action of actions"
            [ngClass]="getActionClasses(action, item)"
            (click)="action.callback(item)"
            [title]="action.tooltip"
            [disabled]="action.disabled && action.disabled(item)"
            class="text-white py-1 px-3 mx-1 rounded font-semibold"
          >
            <i [class]="action.icon"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- 📌 Paginación -->
<div class="flex justify-between items-center mt-6">
  <button
    class="hover:bg-gray-300 border text-gray-800 py-2 px-4 rounded"
    [disabled]="currentPage === 1"
    (click)="changePage(currentPage - 1)"
  >
    Anterior
  </button>
  <span class="text-gray-700"
    >Página {{ currentPage }} de {{ totalPages }}</span
  >
  <button
    class="hover:bg-gray-300 border text-gray-800 py-2 px-4 rounded"
    [disabled]="currentPage === totalPages"
    (click)="changePage(currentPage + 1)"
  >
    Siguiente
  </button>
</div>
